import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType, HttpHeaders } from  '@angular/common/http';
import { map } from  'rxjs/operators';
import {Subject, retry, timer} from 'rxjs';
import { environment } from '../../../environments/environment.prod';
import { EnvironmentLoaderService } from './environment-loader.service';
@Injectable({
  providedIn: 'root',
})
export class FileService {
  // baseUrl = environment.mongoApiUrl+'file/';
  baseUrl = environment.mongoApiUrl;
  careerUrl = environment.careerUrl;
  offerWFUrl = environment.offerWF;
  mongoUrl = environment.mongoApiUrl;
  ExcelUrl = environment.ExcelApiUrl;
  companyHiringTypeId = +localStorage.getItem('fresherCompHiringTypeId');
  validationUrl: any;
  retryDelay = window["retryDelay"];
  constructor(
    private httpClient: HttpClient,
    private envLoaderSerive: EnvironmentLoaderService,
  ) {}
  fileSubject = new Subject<any[]>();
  public getExcelFile(fileID) {
    console.log(this.ExcelUrl);
    const ExcelApiUrl = environment.ExcelApiUrl;
    // this.envLoaderSerive.getEnvData().then(envjson=>{
    //   ExcelApiUrl = envjson['ExcelApiUrl'];
    return this.httpClient.get<any>(ExcelApiUrl + 'cdnFiles/downloadStaticFile?attachmentId=263&fileName=' + fileID);

    // })
  }
  downloadExcelFile(fileID: string): void {
    console.log(this.ExcelUrl);
    const ExcelApiUrl = environment.ExcelApiUrl;
    // this.envLoaderSerive.getEnvData().then(envjson=>{
    //   ExcelApiUrl = envjson['ExcelApiUrl'];
    this.httpClient.get<any>(ExcelApiUrl + 'cdnFiles/downloadStaticFile?attachmentId=263&fileName=' + fileID).subscribe(
      (res) => {
        const base64 = res[0].file; // Base64 content of the file
        const fileName = res[0].fileName; // File name from the response

        // Create a link element to trigger the download
        const link = document.createElement('a');
        link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64}`;
        link.download = fileName; // Set the download attribute to the file name

        // Trigger the download by programmatically clicking the link
        link.click();
      },
      (error) => {
        console.error('Error downloading the file', error);
      },
    );
    //})
  }
  downloadJsonFile(fileID: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const ExcelApiUrl = environment.ExcelApiUrl;
      // this.envLoaderSerive.getEnvData().then(envjson => {
      //   const ExcelApiUrl = envjson['ExcelApiUrl'];
      this.httpClient
        .get<any>(ExcelApiUrl + 'cdnFiles/downloadStaticFile?attachmentId=263&fileName=' + fileID)
        .subscribe(
          (res) => {
            const jsonContent = res[0].file;
            const _fileName = res[0].fileName;
            const content = this.convertBase64ToJson(jsonContent);
            console.log('File content:', content);
            resolve(content);
          },
          (error) => {
            console.error('Error downloading the file', error);
            reject(error);
          },
        );
    });
    //});
  }

  convertBase64ToJson(base64String: string): void {
    const decodedString = atob(base64String);

    const jsonObject = JSON.parse(decodedString);
    return jsonObject;
  }
  public upload(data) {
    const uploadURL = this.baseUrl + 'uploadFileData';
    // let headers = new Headers();
    const requestOptions: object = {
      reportProgress: true,
      observe: 'events',
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Origin': '*',
    };

    const request$ =  this.httpClient.post<any>(uploadURL, data, requestOptions).pipe(
      map((event) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:

          // const progress = Math.round(100 * event.loaded / event.total);
          //   return { status: 'progress', message: progress, progressTime: event.loaded, fileTotalSize:event.total };
          // falls through
          case HttpEventType.Response:
            return event.body;
          default:
            return `Unhandled event: ${event.type}`;
        }
      }),
    );
     return this.retryDelay
      ? request$.pipe(retry({ count: 1, delay: (error) => {
          if (error instanceof HttpErrorResponse && error.status === 502) {
            console.log('retrying now...');
            return timer(this.retryDelay);
          }
          throw error;
        } }))
      : request$;
  }

  public deleteFile(fileID) {
    const uploadURL = this.baseUrl + 'deleteFileData?id=' + fileID;
    return this.httpClient.post(`${uploadURL}`, '', { responseType: 'text' });
  }

  setFileUploadEvent(file: any) {
    this.fileSubject.next(file);
  }

  get fileUploaded() {
    return this.fileSubject.asObservable();
  }

  public downloadFile(fileID)
  {
    return this.httpClient.get<any>(this.baseUrl+'downloadFileNew?id=' + fileID);  
  }

  public getFileData(ojectId, ojectType) {
    return this.httpClient.get<any>(this.baseUrl + 'getFileData/' + ojectId + '/' + ojectType);
  }

  getAttachmentType(objType) {
    return this.httpClient.get<any>(
      this.careerUrl +
        `v1/attachment/getAttachmentTypes?objectType=${objType}&companyHiringTypeId=${this.companyHiringTypeId}`,
    );
  }
  getMultipleAttachments(applicationId) {
    return this.httpClient.get(this.offerWFUrl + 'v1/bpmOnline/getBpmApplicationOfferDetails/' + applicationId);
  }

  downloadFileInArray(modal){
    return this.httpClient.post<any>(this.mongoUrl+"downloadFilesNew",modal);
  }

  getLatestOfferLetter(offerid) {
    return this.httpClient.get(this.mongoUrl + 'getFileId/' + offerid + '/OF/4?fetchType=Latest');
  }

  uploadMultipleFiles(fileList){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=UTF-8'});
    const request$ = this.httpClient.post(this.mongoUrl+"multipleFileDataUpload",fileList,{headers:headers,'responseType':'text'});
    return this.retryDelay
      ? request$.pipe(retry({ count: 1, delay: (error) => {
          if (error instanceof HttpErrorResponse && error.status === 502) {
            console.log('retrying now...');
            return timer(this.retryDelay);
          }
          throw error;
        } }))
      : request$;
  }

  getMultipleFiles(applnId) {
    return this.httpClient.get(this.mongoUrl + 'getAllFilesOfObj/' + applnId + '/OF');
  }

  saveAttachmentMultiple(genericId, companyHiringTypeId, fileData, deletedFile, activityId) {
    console.log(fileData);
    if (deletedFile && deletedFile.length > 0) {
      deletedFile.forEach((fileId) => {
        this.deleteFile(fileId.fileID).subscribe(
          (_res) => {},
          (_err) => {},
        );
      });
    }
    const fileObjArray: any = [];
    if (fileData && fileData.length > 0) {
      (async () => {
        for (const [index, elem] of fileData.entries()) {
          const resp: any = await this.getBase64(elem.file);
          const base64Url_ = resp.split('base64,')[1];
          const fileName = elem.file.name;
          const attachmentId = elem.attachmentId;
          const fileNameSeparation = fileName.lastIndexOf('.');
          const fileNameTxt = fileName.substring(0, fileNameSeparation);
          const fileNameExt = fileName.substring(fileNameSeparation);
          const fileObj = {
            objectId: genericId,
            objectType: 'AP',
            companyHiringTypeId: companyHiringTypeId,
            attachmentId: attachmentId,
            fileType: fileNameExt,
            fileName: fileNameTxt,
            file: base64Url_,
            activityId: +activityId,
          };
          fileObjArray.push(fileObj);
          if (fileObjArray.length >= 1 && fileData.length - 1 == index) {
            this.uploadMultipleFiles(fileObjArray).subscribe(
              (fileData) => {
                console.log(fileData);
              },
              (_error) => {},
            );
          }
        }
      })();
    }
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
}
